import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, onActivated, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

export default defineComponent({
  name: "WorkPlan",
  components: {
    Tabs: Tabs,
    Head: Head,
    Pagination: Pagination
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; //来源标示


    var source = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_source;
    var router = useRouter(); //初始化tab

    var titleArr = ["工作计划/总结", "我的工作计划/总结"];
    var nowTab = ref(0);

    function changeOther(val) {
      nowTab.value = val;
    } //初始化下拉


    var options = ref([{
      value: 0,
      label: "全部"
    }, {
      value: 1,
      label: "工作总结"
    }, {
      value: 2,
      label: "工作计划"
    }]);
    var value = ref(""); //初始化两个table

    var tableData = reactive({
      arr: []
    });
    var totalNum = ref(0);
    var pageIndex = ref(1);
    var summaryType = ref(0);

    function tableone() {
      return _tableone.apply(this, arguments);
    }

    function _tableone() {
      _tableone = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["workselectList"]({
                  pageIndex: pageIndex.value,
                  pageSize: 10,
                  summaryType: summaryType.value > 0 ? summaryType.value : null
                });

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                tableData.arr = data;
                totalNum.value = total;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _tableone.apply(this, arguments);
    }

    var tableDataTwo = reactive({
      arr: []
    });
    var totalNumTwo = ref(0);
    var pageIndexTwo = ref(1);

    function tabletwo() {
      return _tabletwo.apply(this, arguments);
    }

    function _tabletwo() {
      _tabletwo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti2, data, total;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["workselectSelfList"]({
                  pageIndex: pageIndexTwo.value,
                  pageSize: 10
                });

              case 2:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                total = _yield$globalProperti2.total;
                tableDataTwo.arr = data;
                totalNumTwo.value = total;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _tabletwo.apply(this, arguments);
    }

    tableone();
    tabletwo(); //table1 分页

    function changPage(val) {
      pageIndex.value = val;
      tableone();
    }

    function changPageTwo(val) {
      pageIndexTwo.value = val;
      tabletwo();
    } //下拉选择


    function selectChange(val) {
      summaryType.value = val;
      tableone();
    } //删除


    function workselfDel(_x) {
      return _workselfDel.apply(this, arguments);
    } //跳转区域


    function _workselfDel() {
      _workselfDel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(val) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                //TODO可优化进行提示
                ElMessageBox.confirm(globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_del, "温馨提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var _yield$globalProperti3, code;

                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["workselfDel"]({
                            recordId: val
                          });

                        case 2:
                          _yield$globalProperti3 = _context3.sent;
                          code = _yield$globalProperti3.code;

                          if (code == 0) {
                            tabletwo();
                            ElMessage.success("删除成功");
                          } else {
                            ElMessage.error("删除失败");
                          }

                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }))).catch(function () {
                  console.log("失败");
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _workselfDel.apply(this, arguments);
    }

    function godetail(recordId, type) {
      router.push({
        path: "/personal/workPlanDetail",
        query: {
          recordId: recordId,
          type: type
        }
      });
    }

    function addworkself(recordId) {
      router.push({
        path: "/personal/workPlanForm",
        query: {
          recordId: recordId
        }
      });
    } //刷新列表


    onActivated(function () {
      tableone();
      tabletwo();
    });
    return {
      titleArr: titleArr,
      changeOther: changeOther,
      source: source,
      value: value,
      options: options,
      tableData: tableData,
      tableDataTwo: tableDataTwo,
      godetail: godetail,
      nowTab: nowTab,
      totalNum: totalNum,
      addworkself: addworkself,
      changPage: changPage,
      selectChange: selectChange,
      changPageTwo: changPageTwo,
      totalNumTwo: totalNumTwo,
      workselfDel: workselfDel
    };
  }
});